import React, { FC, useState } from "react";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import {
  Col,
  Form,
  Input,
  Upload,
  Row,
  Select,
  notification,
  Switch,
  Space,
  Image,
} from "antd";
import type { UploadFile } from "antd/es/upload/interface";
import styled from "styled-components";
import { SmallText } from "../../../Components/Text3D";
import MultiplyIcon from "../../../assets/images/multiply.png";
import { Button3D, PrimaryButtonX } from "../../../Components/Button3D";
import { CaretDownOutlined, DeleteOutlined } from "@ant-design/icons";
import { GENERATE_PRE_SIGNED_URL_MUTATION } from "../../../Apollo/graphql/Mutation/UploadFile";
import { uploadtoS3 } from "../../../helper/uploadFile";
import { EDIT_PRINTER } from "../../../Apollo/graphql/Mutation/PrintersMutations/EditPrinter";
import { useParams, useHistory } from "react-router-dom";
import {
  GET_SHIPPING_POSTAL_SEARCH,
  GET_SINGLE_PRINTER,
} from "../../../Apollo/graphql/Query";
import FullHeightLoader from "../../../Components/FullHeightLoader";
import { GET_SHIPPING_COUNTRIES } from "../../../Apollo/graphql/Query/GetShippingCountrys";
import { neededColors } from "../../../helper/NeededColors";
import { replaceError } from "../../../utils/utilsFunctions";

const { Option } = Select;

const MainWrapper = styled(Row)`
  /* &:before{
      content: "";
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 20px solid white;
      margin-left: 360px;
    } */
`;

const ContentSection = styled(Col)`
  background-color: #fff;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 2rem;
`;
const Img = styled.img`
  margin: 0 0.8rem;
`;
const InputA = styled(Input)`
  height: 60px;
  background: #ffffff;
  border: 1px solid #d8d8d8;
  box-sizing: border-box;
`;
const SelectX = styled(Select)`
  .ant-select-selector {
    height: 60px !important;
    display: flex;
    align-items: center;
  }
  .ant-select-selection-search {
    display: flex;
    align-items: center;
  }
  .ant-select-single.ant-select-lg:not(.ant-select-customize-input)
    .ant-select-selector {
    height: 60px;
  }
`;
const FilamentDiv = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid black;
  padding: 2rem;
  width: fit-content;
`;

const EditPrinter: FC = () => {
  const history = useHistory();
  const [uploadFileMutation] = useMutation(GENERATE_PRE_SIGNED_URL_MUTATION);
  const [editPrinter] = useMutation(EDIT_PRINTER);
  const { id } = useParams<{ id?: string }>();

  const [imagesList, setImagesList] = useState<UploadFile[]>([]);
  const [thumbnailUrl, setThumbnailUrl] = useState("");
  const [filamentList, setFilamentList] = useState<any>([
    { name: "", price: "", colors: [] },
  ]);
  const [selectedCountry, setSelectedCountry] = useState<any>("");
  const [address, setAddress] = useState<any>();
  const [postServiceCode, setPostServiceCode] = useState<any>(null);
  const [country, setCountry] = useState<any>();
  const [form] = Form.useForm();
  const { data: searchCountries } = useQuery(GET_SHIPPING_COUNTRIES);

  const [
    searchData,
    { data: searchD, loading: searchLoading, error: serchError },
  ] = useLazyQuery(GET_SHIPPING_POSTAL_SEARCH, {});

  const handleAddNewClick = () => {
    setFilamentList([...filamentList, { name: "", price: "", colors: [] }]);
  };
  const handleFilamentChange = (e, idx, keyName) => {
    let tempList = [...filamentList];
    tempList[idx][keyName] = e;
    setFilamentList([...tempList]);
  };

  const handleDeleteFList = (idx) => {
    let List = [...filamentList];
    List.splice(idx, 1);
    setFilamentList(List);
  };

  const { data } = useQuery(GET_SINGLE_PRINTER, {
    fetchPolicy: "network-only",
    variables: {
      printerId: id,
    },
    onCompleted: (data) => {
      if (data?.printer?.countryCode === "AU") {
        setSelectedCountry("australia");
        setPostServiceCode(data?.printer?.postServiceCode);
        setAddress(data?.printer?.postalAddress);
      } else {
        setSelectedCountry("overseas");
      }
      setCountry({ key: data?.printer?.country });

      form.setFieldsValue({
        name: data.printer.name,
        brand: data.printer.brand,
        length: data.printer.length,
        width: data.printer.width,
        height: data.printer.height,
        description: data.printer?.description,
        status: data.printer.active,
        country: data?.printer?.country ? data?.printer?.countryCode : "AU",
        address: data.printer.postalAddress,
        location:
          data?.printer?.countryCode === "AU" ? "australia" : "overseas",
        postalState: data?.printer?.postalState,
        postalCity: data?.printer?.postalCity,
        postalStreet: data?.printer?.postalStreet,
        postServiceCode: data?.printer?.postServiceCode,
      });
      if (data.printer && data.printer.filaments) {
        let tempFils = data.printer.filaments.map((sig) => ({
          name: sig.name,
          price: sig.price,
          colors: sig.colors,
        }));
        setFilamentList(tempFils);
      }
      if (data.printer) {
        setThumbnailUrl(data.printer.featuredImage);
        // setFileUrl(data.printer.images);
        let tempFiles = data.printer.images.map((imageUrl, idx) => ({
          uid: idx+1,
          name: 'image-'+idx+1 ,
          status: "done",
          url: imageUrl,
        }));
        setImagesList(tempFiles);
      }
    },
  });

  const onFinish = (values: any) => {
    if (!thumbnailUrl) {
      notification.error({
        message: "error",
        description: "Please upload atleast one thumbnail image",
      });
      return;
    }
    const printerImages = imagesList.map(img => img.url)
    editPrinter({
      variables: {
        printerId: id,
        input: {
          name: values.name,
          brand: values.brand,
          length: Number(values.length),
          height: Number(values.height),
          width: Number(values.width),
          featuredImage: thumbnailUrl,
          description: values.description,
          images: printerImages,
          active: values.status,
          filaments: filamentList,
          countryCode: selectedCountry === "overseas" ? values.country : "AU",
          postalAddress: selectedCountry === "australia" ? address : null,
          postServiceCode:
            selectedCountry === "australia"
              ? postServiceCode.toString()
              : values.postServiceCode,
          postalState: values.postalState,
          postalCity: values.postalCity,
          postalStreet: values.postalStreet,
          country:
            selectedCountry === "overseas"
              ? country?.key
              : selectedCountry.toUpperCase(),
        },
      },
    })
      .then((data) => {
        history.goBack();
      })
      .catch((err) => {
        notification.error({
          message: "Error",
          description: replaceError(err),
        });
      });
  };
  const onFinishFailed = (errorInfo: any) => {
    notification.info({
      message: "Info",
      description: "Please fill all the required fields",
    });
  };

  // printer image
  const imageProps = {
    name: "file",
    multiple: false,
    beforeUpload: async (file: any) => {
      try {
        const {
          data: {
            generate3dPreSignedURL: { url },
          },
        } = await uploadFileMutation({
          variables: {
            input: {
              type: "put",
              fileId: file.uid,
              mime: file.type,
            },
          },
        });
        if (url) {
          uploadtoS3(url, file, 1)
            .then((data) => {
              const mainUrl = url.split("?")[0];
              setImagesList([
                ...imagesList,
                {
                  uid: (imagesList.length + 1).toString(),
                  name: "image-" + imagesList.length + 1,
                  status: "done",
                  url: mainUrl,
                },
              ]);
            })
            .catch((err) => {
              notification.error({
                message: "error",
                description: "Oops, something went wrong while uploading image",
              });
            });
        }
      } catch (err) {
        notification.error({
          message: "error",
          description: "Oops, something went wrong while uploading image",
        });
      }
      return false;
    },
    onRemove: async (file: any) => {
      const newImages = imagesList.filter(img => img.url !== file.url);
      setImagesList(newImages);
    },
  };
  // thumbnail
  const thumbNailProps = {
    name: "file",
    multiple: false,
    beforeUpload: async (file: any) => {
      try {
        const {
          data: {
            generate3dPreSignedURL: { url },
          },
        } = await uploadFileMutation({
          variables: {
            input: {
              type: "put",
              fileId: file.uid,
              mime: file.type,
            },
          },
        });
        if (url) {
          uploadtoS3(url, file, 1)
            .then((data) => {
              setThumbnailUrl(url.split("?")[0]);
            })
            .catch((err) => {
              notification.error({
                message: "error",
                description: "Oops, something went wrong while uploading thumbnail image",
              });
            });
        }
      } catch (err) {
         notification.error({
           message: "error",
           description:
             "Oops, something went wrong while uploading thumbnail image",
         });
      }
      return false;
    },
    onRemove: async (file: any) => {
      setThumbnailUrl("");
    },
  };
  const handleInputSearch = (searchquery) => {
    if (searchquery.length >= 3) {
      searchData({
        variables: {
          search: searchquery,
        },
      });
    }
  };

  const handleLocationChange = (value) => {
    setSelectedCountry(value);
    form.setFieldsValue({
      countryCode: null,
      postalAddress: null,
      postServiceCode: null,
      postalState: null,
      postalCity: null,
      postalStreet: null,
      country: null,
    });
  };

  return (
    <>
      <MainWrapper>
        <ContentSection>
          <SmallText size line bold style={{ padding: "2rem 0" }}>
            {id ? "Edit Printer" : "add new printer"}
          </SmallText>
          {!data?.printer && <FullHeightLoader />}
          {data && data.printer && (
            <Form
              labelCol={{ span: 24 }}
              form={form}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
            >
              <Form.Item
                label="Name"
                name="name"
                rules={[
                  {
                    required: true,
                    message: "Name is required",
                  },
                ]}
              >
                <InputA style={{ width: "45%" }} placeholder="Printer Name" />
              </Form.Item>
              <Form.Item
                label="Brand"
                name="brand"
                rules={[
                  {
                    required: true,
                    message: "please enter brand",
                  },
                ]}
              >
                <InputA placeholder="Brand Name" style={{ width: "45%" }} />
              </Form.Item>
              <Form.Item label="Dimension( L x W x H) in mm">
                <Space style={{ display: "flex", width: "100%" }}>
                  <Form.Item label="" name="length">
                    <InputA placeholder="200" type="number" />
                  </Form.Item>
                  <Img src={MultiplyIcon} alt=""></Img>
                  <Form.Item label="" name="width">
                    <InputA placeholder="200" type="number" />
                  </Form.Item>
                  <Img src={MultiplyIcon} alt=""></Img>
                  <Form.Item label="" name="height">
                    <InputA placeholder="200" type="number" />
                  </Form.Item>
                </Space>
              </Form.Item>
              <div style={{ display: "flex", flexFlow: "row" }}>
                <Form.Item
                  label="Printer Location"
                  name="location"
                  rules={[
                    {
                      required: true,
                      message: "Printer location is required",
                    },
                  ]}
                >
                  <SelectX
                    size="large"
                    placeholder="Select the country"
                    defaultActiveFirstOption={false}
                    style={{ width: 200 }}
                    filterOption={false}
                    dropdownMatchSelectWidth={false}
                    onChange={(value) => handleLocationChange(value)}
                    notFoundContent={null}
                  >
                    <Option value="australia">Australia</Option>
                    <Option value="overseas">Overseas</Option>
                  </SelectX>
                </Form.Item>
                {selectedCountry && selectedCountry === "australia" && (
                  <Form.Item
                    label="Post/Zip code"
                    name="address"
                    style={{ marginLeft: "1rem" }}
                    rules={[
                      {
                        required: true,
                        message: "Please select postal address",
                      },
                    ]}
                  >
                    <SelectX
                      size="large"
                      showSearch
                      placeholder="Search"
                      defaultActiveFirstOption={false}
                      dropdownMatchSelectWidth={false}
                      style={{ width: 200 }}
                      disabled={selectedCountry === "overseas"}
                      filterOption={false}
                      onSearch={handleInputSearch}
                      onChange={(e: any, obj: any) => {
                        setPostServiceCode(+e.split("_")[0]);
                        setAddress(obj?.children?.toString().replace(/,/g, ""));
                      }}
                      notFoundContent={null}
                    >
                      {searchLoading && (
                        <Option value="search" disabled={true}>
                          Searching....
                        </Option>
                      )}
                      {serchError && (
                        <Option value="error" disabled={true}>
                          data not found
                        </Option>
                      )}
                      {searchD &&
                        searchD?.shippingPostalSearch?.map((s) => (
                          <Option key={s.id} value={`${s.postcode}_${s.id}`}>
                            {s.location} {s.state} {s.postcode}
                          </Option>
                        ))}
                    </SelectX>
                  </Form.Item>
                )}
                {selectedCountry && selectedCountry === "overseas" && (
                  <>
                    <Form.Item
                      label="Country"
                      name="country"
                      style={{ marginLeft: "1rem" }}
                      rules={[
                        {
                          required: true,
                          message: "please select country",
                        },
                      ]}
                    >
                      <SelectX
                        size="large"
                        showSearch
                        placeholder="Search"
                        defaultActiveFirstOption={false}
                        style={{ width: 200 }}
                        dropdownMatchSelectWidth={false}
                        filterOption={false}
                        onChange={(e, obj) => setCountry(obj)}
                        notFoundContent={null}
                      >
                        {searchCountries &&
                          searchCountries?.shippingCountries?.map((s) => (
                            <Option key={s.name} value={s.code}>
                              {s.name}
                            </Option>
                          ))}
                      </SelectX>
                    </Form.Item>
                    <Form.Item
                      label="Post/Zip code"
                      name="postServiceCode"
                      rules={[
                        {
                          required: true,
                          message: "Post/Zip code is required",
                        },
                      ]}
                    >
                      <InputA
                        placeholder=""
                        name="postServiceCode"
                        style={{ width: "45%" }}
                      />
                    </Form.Item>
                  </>
                )}
              </div>
              <Form.Item
                label="City"
                name="postalCity"
                rules={[
                  {
                    required: true,
                    message: "City is required",
                  },
                ]}
              >
                <InputA
                  placeholder=""
                  name="postalCity"
                  style={{ width: "45%" }}
                />
              </Form.Item>
              <Form.Item
                label="State"
                name="postalState"
                rules={[
                  {
                    required: true,
                    message: "State is required",
                  },
                ]}
              >
                <InputA
                  placeholder=""
                  name="postalState"
                  style={{ width: "45%" }}
                />
              </Form.Item>
              <Form.Item
                label="Street Address"
                name="postalStreet"
                rules={[
                  {
                    required: true,
                    message: "Street Address is required",
                  },
                ]}
              >
                <InputA
                  placeholder=""
                  name="postalStreet"
                  style={{ width: "45%" }}
                />
              </Form.Item>
              <Form.Item label="Status" name="status">
                <Switch
                  checkedChildren="active"
                  unCheckedChildren="inactive"
                  defaultChecked={data?.printer?.active}
                />
              </Form.Item>
              <Form.Item label="Add Filaments">
                <FilamentDiv>
                  {filamentList.length > 0 &&
                    filamentList.map((s, idx) => (
                      <div
                        key={s}
                        data-name={s.name}
                        style={{ marginTop: "1rem", display: "flex" }}
                      >
                        <Form.Item style={{ width: "150px" }}>
                          <SelectX
                            style={{
                              marginRight: "2rem",
                              height: "60px",
                            }}
                            suffixIcon={<CaretDownOutlined />}
                            placeholder="material"
                            optionFilterProp="children"
                            value={s.name}
                            dropdownMatchSelectWidth={false}
                            onChange={(e) =>
                              handleFilamentChange(e, idx, "name")
                            }
                          >
                            <Option value="ABS">ABS</Option>
                            <Option value="PLA">PLA</Option>
                            <Option value="PLA_PLUS">PLA+</Option>
                            <Option value="PET">PET</Option>
                            <Option value="PETG">PETG</Option>
                            <Option value="RESIN ">RESIN</Option>
                            <Option value="NYLON">NYLON</Option>
                            <Option value="NYLON_CARBON_FIBER">
                              NYLON CARBON FIBER
                            </Option>
                            <Option value="TPU">TPU</Option>
                            <Option value="HIPS">HIPS</Option>
                            <Option value="PVA">PVA</Option>
                            <Option value="SANDSTONE">SANDSTONE</Option>
                            <Option value="CERAMICS">CERAMICS</Option>
                            <Option value="STEEL">STEEL</Option>
                            <Option value="WOOD">WOOD</Option>
                            <Option value="POLYCARBONATE">POLYCARBONATE</Option>
                          </SelectX>
                        </Form.Item>
                        <Form.Item
                          style={{ width: "150px", marginLeft: "2rem" }}
                        >
                          <InputA
                            placeholder="Price $/gram"
                            style={{
                              marginRight: "2rem",
                              marginTop: "0px",
                            }}
                            type="number"
                            value={s.price}
                            onChange={(e) =>
                              handleFilamentChange(
                                Number(e.target.value),
                                idx,
                                "price"
                              )
                            }
                          />
                        </Form.Item>
                        <Form.Item
                          style={{ width: "150px", marginLeft: "2rem" }}
                        >
                          <SelectX
                            placeholder="Choose color"
                            mode="multiple"
                            value={s.colors && s.colors}
                            onChange={(e) =>
                              handleFilamentChange(e, idx, "colors")
                            }
                            style={{ marginRight: "2rem", marginTop: "0px" }}
                          >
                            {neededColors.map((it) => (
                              <Option value={it}>{it}</Option>
                            ))}
                          </SelectX>
                        </Form.Item>
                        {filamentList.length > 1 && (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginTop: "-20px",
                              marginLeft: "2rem",
                            }}
                          >
                            <DeleteOutlined
                              onClick={() => handleDeleteFList(idx)}
                            />
                          </div>
                        )}
                      </div>
                    ))}
                  <div>
                    <PrimaryButtonX
                      type="primary"
                      onClick={handleAddNewClick}
                      style={{ marginTop: "1rem" }}
                    >
                      Add More
                    </PrimaryButtonX>
                  </div>
                </FilamentDiv>
              </Form.Item>
              <Form.Item label="Description" name="description">
                <Input.TextArea rows={4} />
              </Form.Item>
              <div
                style={{
                  display: "flex",
                  marginTop: "3rem",
                  justifyContent: " space-between",
                }}
              >
                <div style={{ display: "flex" }}>
                  <Form.Item>
                    <Upload {...thumbNailProps}>
                      <Button3D
                        type="primary"
                        style={{ marginRight: "1.5rem" }}
                      >
                        {thumbnailUrl ? "Change Thumbnail" : "upload thumbnail"}
                      </Button3D>
                    </Upload>
                    {thumbnailUrl && (
                      <div style={{ marginTop: "10px" }}>
                        <Image src={thumbnailUrl} height={80} />
                      </div>
                    )}
                  </Form.Item>
                  <Form.Item>
                    <Upload
                      {...imageProps}
                      listType="picture"
                      fileList={imagesList}
                    >
                      <Button3D style={{ border: "2px solid #1196DD" }}>
                        upload images
                      </Button3D>
                    </Upload>
                  </Form.Item>
                </div>
                <div>
                  <Form.Item>
                    <Button3D
                      type="primary"
                      htmlType="submit"
                      style={{
                        background: "rgba(9, 185, 79, 1)",
                        marginRight: "1.5rem",
                      }}
                    >
                      Update
                    </Button3D>
                  </Form.Item>
                </div>
              </div>
            </Form>
          )}
        </ContentSection>
      </MainWrapper>
    </>
  );
};

export default EditPrinter;
